import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetDefaultMiscCosts = async (serviceOfferingID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams({
        serviceOfferingID: serviceOfferingID,
      }).toString();

      const response = await fetch(
        `${dev_baseUrl}/Service/getDefaultMiscCosts?${queryParams}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { isError: true, message: "Access token is missing." };
  }
};

export const SaveDefaultMiscCost = async (serviceOfferingID, miscCost, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      let Payload = {
        defaultJobMiscCostID: miscCost.defaultJobMiscCostID || 0,
        serviceOfferingID: serviceOfferingID,
        costName: miscCost.costName,
        costAmount: miscCost.costAmount,
        customerPrice: miscCost.customerPrice,
        billToCustomer: miscCost.billToCustomer,
      };

      const response = await fetch(
        `${dev_baseUrl}/Service/saveDefaultMiscCost`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(Payload),
        }
      );

      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};

export const DeleteDefaultMiscCost = async (defaultJobMiscCostID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(
        `${dev_baseUrl}/Service/deleteDefaultMiscCost/${defaultJobMiscCostID}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { isError: true, message: "Access token is missing." };
  }
};
